import { useMemo } from 'react';
import { useAuth } from '../../../../../authContext';
import { useSecurity } from '../../../../../SecurityContext';
import { normalizeRosterStr } from '../../rosterTools/utils/rosterHelpers';

/** Owner check + roster statistics read permission (view-as uses subject). */
export function useDashboardStatisticsAccess(player, options = {}) {
  const { extraReadResourceKey = null } = options;
  const { isLoggedIn, userId, handles } = useAuth();
  const { subjectHasPermission, userHasPermission, isViewAsActive, viewAsUserId } = useSecurity();

  const isOwner = useMemo(() => {
    if (!isLoggedIn || !player) return false;
    const puid = player.userId;
    if (isViewAsActive) {
      if (puid != null && viewAsUserId != null) {
        return Number(puid) === Number(viewAsUserId);
      }
      return false;
    }
    if (puid != null && userId != null) return Number(puid) === Number(userId);
    const rosterHandle = normalizeRosterStr(player.rosterHandle);
    if (!rosterHandle) return false;
    const authHandles = Array.isArray(handles) ? handles : [];
    return authHandles.some((h) => normalizeRosterStr(h?.handle) === rosterHandle);
  }, [handles, isLoggedIn, isViewAsActive, player, userId, viewAsUserId]);

  const canViewStatistics = useMemo(() => {
    if (isOwner) return true;
    if (
      extraReadResourceKey &&
      userHasPermission(extraReadResourceKey, 'read')
    ) {
      return true;
    }
    return subjectHasPermission('private.navbar.roster.file.statistics', 'read');
  }, [extraReadResourceKey, isOwner, subjectHasPermission, userHasPermission]);

  return { canViewStatistics };
}
